import {Component} from "@angular/core";
import {IonicPage, LoadingController, NavParams, ToastController} from 'ionic-angular';

import {QuizzServerProvider} from '../../providers/quizz-server/quizz-server';

/**
 * Generated class for the QuizzDetailPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-quizz-detail',
  templateUrl: 'quizz-detail.html',
})
export class QuizzDetailPage {

  loading: boolean = false;
  quizz: any = null;
  performanceGraphUrl: string = null;

  constructor(
    private navParams: NavParams,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private quizzServerProvider: QuizzServerProvider
  ) {
    this.loading = true;

    let loader = this.loadingCtrl.create({
      content: 'Obtendo detalhe da Certificação Continuada...',
    });
    loader.present();

    let that = this;
    this.quizz = this.navParams.get('quizz');

    this.quizzServerProvider.fetch(this.quizz.id).subscribe((quizz: any) => {
      that.loading = false;
      loader.dismiss();

      try {
        if (that.quizz !== null) {
          // if (quizz.startAt) {
          //   quizz.startAt = new Date(quizz.startAt.replace(/\s+/g, 'T').concat('.000-03:00'));
          // }

          // if (quizz.endAt) {
          //   quizz.finishedAt = new Date(quizz.endAt.replace(/\s+/g, 'T').concat('.000-03:00'));
          // }

          that.performanceGraphUrl = that.quizzServerProvider.fetchPerfomanceGraphUrl(this.quizz.id);

          that.quizz = quizz;
        }
      } catch (ex) {
        that.doNotRetrivedProof(ex);
      }
    }, (error: any) => {
      that.loading = false;
      loader.dismiss();
      that.doNotRetrivedProof(error);
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad QuizzDetailPage');
  }

  private doNotRetrivedProof(error = null) {
    this.quizz = null;

    console.log('Não foi possível obter detalhe da Certificação Continuada.', error);

    let toast = this.toastCtrl.create({
      message: 'Não foi possível obter detalhe da Certificação Continuada.',
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/quizz-detail/quizz-detail.ts